import { render } from "./sidebar.vue?vue&type=template&id=77340fa8&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=77340fa8&lang=less&scoped=true"

import exportComponent from "/home/runner/work/easticloud-admin/easticloud-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77340fa8"]])

export default __exports__